var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"8c05bc694640e023aace5f6e6cf2a860c9ffe871"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["website@scale-ai"]={id:"8c05bc694640e023aace5f6e6cf2a860c9ffe871"};
      